import { ArrowUpRight } from "lucide-react";

export const ServiceCard = ({ service, index, compact = false }) => {
  const Icon = service.icon;
  return (
    <article data-testid={`service-card-${service.id}`}
      className="card-tech rise group relative flex flex-col rounded-2xl p-6 sm:p-8 hover:-translate-y-1"
      style={{ animationDelay: `${index * 70}ms` }}>
      <div className="mb-6 flex items-center justify-between">
        <span className="grid h-11 w-11 place-items-center rounded-xl border border-cyan-400/25 bg-cyan-400/10 text-cyan-300 transition-shadow duration-300 group-hover:shadow-[0_0_24px_rgba(0,240,255,0.35)]">
          <Icon className="h-5 w-5" />
        </span>
        <span className="font-mono-tech text-[11px] uppercase tracking-widest text-slate-500">
          0{index + 1} / {service.tag}
        </span>
      </div>
      <h3 className="text-xl font-semibold tracking-tight text-white">{service.title}</h3>
      <p className="mt-3 text-sm leading-relaxed text-slate-400">{service.summary}</p>
      {!compact && (
        <ul className="mt-6 space-y-2 border-t border-white/5 pt-5">
          {service.deliverables.map((d) => (
            <li key={d} className="flex items-center gap-2.5 text-sm text-slate-300">
              <span className="h-1 w-1 rounded-full bg-cyan-400" /> {d}
            </li>
          ))}
        </ul>
      )}
      {!compact && (
        <a href="/contact" data-testid={`service-inquire-${service.id}`}
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-cyan-300 transition-colors hover:text-white">
          Ask about this <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      )}
    </article>
  );
};
